module.exports = __webpack_public_path__ + "static/img/200157.ffbef657.png";